import { createApp } from 'vue'
import App from './App.vue'
import Vant from 'vant';
import { Toast } from 'vant';
import router from './router'
import 'vant/lib/index.css';
import axios from 'axios';

// 配置全局的 axios 请求拦截器
axios.interceptors.request.use(
  config => {
    // 从 localStorage 中获取 companyId
    const companyId = localStorage.getItem('companyId');
    if (companyId) {
      // 添加到请求头中
      config.headers['companyId'] = companyId;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

router.beforeEach((to, from, next) => {
    window.document.title = to.meta.title == undefined?'默认标题':to.meta.title
    if (to.meta.requireAuth) {
        next({
            path: '/login',
            query: {
                redirect: to.fullPath
            }
        })
    }
    next();
})

createApp(App).use(router).use(Toast).use(Vant).mount('#app')

